import api from '@/services/api';

const ENTITY_ENDPOINT = 'elemento-grupo';

const elemento_grupo_service = {
  /**
   * Obtiene todos los elementos grupo con parámetros de paginación y filtros
   * @param {string} params - Parámetros de consulta como string
   * @returns {Promise} Respuesta de la API
   */
  async findAll(params) {
    try {
      const response = await api.get(`/${ENTITY_ENDPOINT}?${params}`);
      return response;
    } catch (error) {
      console.error('Error finding all elemento grupo:', error);
      throw error;
    }
  },

  /**
   * Busca un elemento grupo por su código
   * @param {string} codigo - Código del elemento grupo
   * @returns {Promise} Respuesta de la API
   */
  async findByCodigo(codigo) {
    try {
      const response = await api.get(`/${ENTITY_ENDPOINT}/${codigo}`);
      return response;
    } catch (error) {
      console.error(`Error finding elemento grupo with codigo ${codigo}:`, error);
      throw error;
    }
  },

  /**
   * Crea un nuevo elemento grupo
   * @param {Object} data - Datos del elemento grupo a crear
   * @returns {Promise} Respuesta de la API
   */
  async create(data) {
    try {
      const response = await api.post(`/${ENTITY_ENDPOINT}`, data);
      return response;
    } catch (error) {
      console.error('Error creating elemento grupo:', error);
      throw error;
    }
  },

  /**
   * Actualiza un elemento grupo existente
   * @param {string} codigo - Código del elemento grupo a actualizar
   * @param {Object} data - Datos actualizados del elemento grupo
   * @returns {Promise} Respuesta de la API
   */
  async update(codigo, data) {
    try {
      const response = await api.patch(`/${ENTITY_ENDPOINT}/${codigo}`, data);
      return response;
    } catch (error) {
      console.error(`Error updating elemento grupo with codigo ${codigo}:`, error);
      throw error;
    }
  },

  /**
   * Elimina un elemento grupo por su código
   * @param {string} codigo - Código del elemento grupo a eliminar
   * @returns {Promise} Respuesta de la API
   */
  async delete(codigo) {
    try {
      const response = await api.delete(`/${ENTITY_ENDPOINT}/${codigo}`);
      return response;
    } catch (error) {
      console.error(`Error deleting elemento grupo with codigo ${codigo}:`, error);
      throw error;
    }
  },

  /**
   * Obtiene los elementos tipo asociados a un grupo específico
   * @param {string} codigoGrupo - Código del grupo de elementos
   * @returns {Promise} Respuesta de la API con los elementos tipo del grupo
   */
  async getGrupoDefaults(codigoGrupo, modulo) {
    try {
      const response = await api.get(`/${ENTITY_ENDPOINT}/${codigoGrupo}/detail/default/${modulo}`);
      return response.data || [];
    } catch (error) {
      console.error(`Error getting elementos tipo for grupo ${codigoGrupo}:`, error);
      throw error;
    }
  },
};

export default elemento_grupo_service;
